(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["think27-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Footer accordions (think27). State only: the lists are closed on phones by the server-rendered
     aria-expanded="false"; on wider screens CSS always shows them and the headings leave the tab order. */
  var mq = window.matchMedia('(max-width: 700px)');
  function sync(root) {
    var phone = mq.matches;
    var btns = (root || document).querySelectorAll('.t27ft--accordion .t27ft-col-h');
    for (var i = 0; i < btns.length; i++) {
      if (phone) {
        btns[i].removeAttribute('tabindex');
        btns[i].removeAttribute('aria-hidden');
        if (btns[i].getAttribute('data-t27ft-open') !== '1') btns[i].setAttribute('aria-expanded', 'false');
      } else {
        btns[i].setAttribute('aria-expanded', 'true');
        btns[i].setAttribute('tabindex', '-1');
      }
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.t27ft--accordion .t27ft-col-h');
    if (!b || !mq.matches) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    b.setAttribute('data-t27ft-open', open ? '0' : '1');
  });
  /* Country list lives in a <template> until the selector is first opened (speed pass 2, 24-Sep). */
  function t27ftLoc(e) {
    var t = e.target.closest && e.target.closest('.t27ft-loc .localization-toggle');
    if (!t) return;
    var tpls = document.querySelectorAll('.t27ft-loc template.t27ft-loc-tpl');
    for (var i = 0; i < tpls.length; i++) {
      var tp = tpls[i], dataEl = tp.nextElementSibling;
      if (dataEl && dataEl.classList.contains('t27ft-loc-data')) {
        var list = []; try { list = JSON.parse(dataEl.textContent); } catch (err) {}
        var box = document.createElement('x-listbox'); box.className = 'popover__value-list';
        var flags = tp.getAttribute('data-flags') === '1';
        list.forEach(function (c) {
          var btn = document.createElement('button');
          btn.type = 'submit'; btn.name = 'country_code'; btn.className = 'popover__value-option h-stack gap-2.5';
          btn.setAttribute('role', 'option'); btn.value = c[0]; btn.setAttribute('aria-selected', c[4] ? 'true' : 'false');
          if (flags) { var im = document.createElement('img'); im.src = '//cdn.shopify.com/static/images/flags/' + c[0].toLowerCase() + '.svg?format=jpg&width=60'; im.alt = c[1]; im.width = 60; im.height = 45; im.loading = 'lazy'; im.className = 'country-flag'; btn.appendChild(im); }
          var sp = document.createElement('span'); sp.textContent = c[1] + ' (' + c[2] + (c[3] ? ' ' + c[3] : '') + ')'; btn.appendChild(sp);
          box.appendChild(btn);
        });
        dataEl.remove(); tp.replaceWith(box);
      } else { tp.replaceWith(tp.content); }
    }
  }
  document.addEventListener('pointerdown', t27ftLoc, true);
  document.addEventListener('focusin', t27ftLoc, true);
  document.addEventListener('click', t27ftLoc, true);
  if (mq.addEventListener) mq.addEventListener('change', function () { sync(); });
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["think27-pk-finder"] && !Shopify.designMode) return;
  try {
    
/* think27 design finder: re-scores the family cards when the visitor picks a chip (prototype rule:
   question 1 +w1, question 2 +w2, question 3 +w3, "any" matches all, custom minus the penalty; top two,
   ties keep block order). State only: it sets data-rank and hidden on the cards. */
(function () {
  function bind(root) {
    var els = root.querySelectorAll('[data-pk-fd]');
    for (var e = 0; e < els.length; e++) {
      (function (el) {
        if (el.getAttribute('data-fd-bound')) return;
        el.setAttribute('data-fd-bound', '1');
        var w = [0, +el.getAttribute('data-w1') || 0, +el.getAttribute('data-w2') || 0, +el.getAttribute('data-w3') || 0];
        var pen = +el.getAttribute('data-pen') || 0;
        function ans(i) { var r = el.querySelector('input[data-fd-q="' + i + '"]:checked'); return r ? r.value : ''; }
        function update() {
          var a = [null, ans(1), ans(2), ans(3)];
          var cards = el.querySelectorAll('.pk-fd-card'), sc = [];
          for (var c = 0; c < cards.length; c++) {
            var s = 0;
            for (var i = 1; i <= 3; i++) {
              var t = cards[c].getAttribute('data-t' + i) || '';
              if (a[i] === 'any' || (a[i] && t.indexOf(',' + a[i] + ',') > -1)) s += w[i];
            }
            if (cards[c].getAttribute('data-custom') === '1') s -= pen;
            sc.push(s);
          }
          var b = -1, bs = -Infinity, s2 = -1, ss = -Infinity, k;
          for (k = 0; k < sc.length; k++) if (sc[k] > bs) { bs = sc[k]; b = k; }
          for (k = 0; k < sc.length; k++) if (k !== b && sc[k] > ss) { ss = sc[k]; s2 = k; }
          for (k = 0; k < cards.length; k++) {
            var rank = k === b ? 1 : k === s2 ? 2 : 0;
            cards[k].setAttribute('data-rank', rank);
            if (rank) cards[k].removeAttribute('hidden'); else cards[k].setAttribute('hidden', '');
          }
        }
        el.addEventListener('change', function (ev) { if (ev.target && ev.target.hasAttribute('data-fd-q')) update(); });
      })(els[e]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (ev) { bind(ev.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["think27-pk-form"] && !Shopify.designMode) return;
  try {
    
/* think27-pk-form: fill ONE field from the link (24-Sep, careers roles -> the "Which role?" dropdown).
   Only forms whose grid carries data-pk-prefill="<key>" take part. Understands ?<key>=… in the page
   address and #<anchor>?<key>=… in the hash; a click on such a link to THIS page is handled here (no
   reload). A dropdown matches its choices exactly, ignoring case, or as a slug (design-and-studio). It
   only sets a value and the email subject: nothing changes size. */
(function () {
  var grids = document.querySelectorAll('.t27pk .pk-fm-grid[data-pk-prefill]');
  if (!grids.length) return;
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function read(href, key, hashOnly) {
    var u;
    try { u = new URL(href, location.href); } catch (e) { return null; }
    var h = u.hash, q = h.indexOf('?'), v = null;
    if (q > -1) { try { v = new URLSearchParams(h.slice(q + 1)).get(key); } catch (e) { v = null; } }
    if (v === null && !hashOnly) v = u.searchParams.get(key);
    return { v: v, anchor: decodeURIComponent(q > -1 ? h.slice(1, q) : h.slice(1)), path: u.pathname, origin: u.origin };
  }
  function field(g) {
    var name = 'contact[' + g.getAttribute('data-pk-prefill') + ']';
    var els = g.querySelectorAll('select,input,textarea');
    for (var i = 0; i < els.length; i++) { if (els[i].name === name) return els[i]; }
    return null;
  }
  function subject(g, f) {
    if (!g.hasAttribute('data-pk-prefill-subject') || !f) return;
    var form = g.closest('form');
    var s = form && form.querySelector('input[name="contact[subject]"]');
    if (!s) return;
    /* the original subject comes from the server (a hidden input's value is its own attribute, and
       browsers may restore it on reload), so the choice is never added twice */
    var base = g.getAttribute('data-pk-prefill-subject');
    var v = String(f.value || '').trim();
    s.value = v ? base + ': ' + v : base;
  }
  function fill(g, v) {
    var f = field(g);
    v = String(v === null || v === undefined ? '' : v).trim();
    if (!f || !v) return false;
    if (f.tagName === 'SELECT') {
      var hit = null;
      for (var i = 0; i < f.options.length; i++) {
        var o = f.options[i].value;
        if (!o) continue;
        if (o === v || o.toLowerCase() === v.toLowerCase() || slug(o) === slug(v)) { hit = o; break; }
      }
      if (hit === null) return false;
      f.value = hit;
    } else {
      f.value = v.slice(0, 120);
    }
    subject(g, f);
    return true;
  }
  function band(g) { return g.closest('[id].t27pk'); }
  function arrive(hashOnly) {
    for (var i = 0; i < grids.length; i++) {
      var g = grids[i], r = read(location.href, g.getAttribute('data-pk-prefill'), hashOnly), b = band(g);
      if (!r || r.v === null || !fill(g, r.v)) continue;
      /* #anchor?key=… is not a real id, so the browser did not jump: swap the hash for the plain #anchor
         (no new history entry) and let the browser make its own jump, which keeps the form in place
         while the rest of the page finishes loading */
      if (b && location.hash.indexOf('?') > -1 && r.anchor === b.id) location.replace('#' + b.id);
    }
  }
  for (var i = 0; i < grids.length; i++) {
    (function (g) {
      g.addEventListener('change', function (e) { if (e.target === field(g)) subject(g, e.target); });
    })(grids[i]);
  }
  arrive(false);
  window.addEventListener('hashchange', function () { arrive(true); });
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self')) return;
    for (var i = 0; i < grids.length; i++) {
      var g = grids[i], b = band(g), r = read(a.href, g.getAttribute('data-pk-prefill'), false);
      if (!b || !r || r.v === null || r.origin !== location.origin || r.path !== location.pathname || r.anchor !== b.id) continue;
      e.preventDefault();
      fill(g, r.v);
      if (location.hash === '#' + b.id) { b.scrollIntoView(); } else { location.hash = b.id; }
      return;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["think27-pk-planner"] && !Shopify.designMode) return;
  try {
    
/* think27 size planner: recomputes the recommendation when the visitor moves a slider or picks a chip.
   Same formula as the Liquid default. State only: text, one image's hidden flag and a link change. */
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function fill(t, m) { return String(t || '').replace(/\{(\w+)\}/g, function (s, k) { return m[k] != null ? m[k] : s; }); }
  function bind(root) {
    var els = root.querySelectorAll('[data-pk-pl]');
    for (var e = 0; e < els.length; e++) {
      (function (el) {
        if (el.getAttribute('data-pl-bound')) return;
        var cfgEl = el.querySelector('[data-pl-cfg]');
        if (!cfgEl) return;
        var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (x) { return; }
        if (!cfg.fam || !cfg.fam.length) return;
        el.setAttribute('data-pl-bound', '1');
        function q(s) { return el.querySelector(s); }
        function num(k) { var i = q('[data-pl="' + k + '"]'); return i ? +i.value : 0; }
        function pick(k) { var i = q('[data-pl="' + k + '"]:checked'); return i ? i.value : null; }
        function ico(n) { var t = q('[data-pl-ico="' + n + '"]'); return t ? t.innerHTML : ''; }
        function text(s, v) { var n = q(s); if (n) n.textContent = v; }
        var raf = 0;
        function update() {
          raf = 0;
          var fi = +(pick('place') || 0), f = cfg.fam[fi] || cfg.fam[0];
          var post = pick('posture') || 'floor';
          var width = num('width'), height = num('height'), idol = num('idol');
          var usable = width - cfg.gs, fits = usable >= f.w[0];
          var w = Math.round(clamp(usable, f.w[0], f.w[1]));
          var mount = cfg.mount[post] || cfg.mount.floor;
          var mid = Math.round((mount[0] + mount[1]) / 2);
          var room = f.kind === 'wall' ? height - mid - cfg.gt : height - cfg.gt;
          var h = Math.round(clamp(room, f.h[0], f.h[1]));
          var inner = Math.round(h * f.inner / 100), need = idol + cfg.gi;
          var tok = { inner: inner, idol: idol, need: need, m1: mount[0], m2: mount[1], posture: cfg.ptxt[post] || '' };
          var notes = [];
          if (!fits && f.tight) notes.push(['shield', f.tight]);
          if (room < f.h[0] && cfg.note.low) notes.push(['shield', cfg.note.low]);
          notes.push(inner >= need ? ['check', cfg.note.ok] : ['shield', cfg.note.short]);
          var mn = f.kind === 'wall' ? cfg.note.wall : f.kind === 'table' ? cfg.note.table : (post === 'floor' ? cfg.note.flow : cfg.note.fhigh);
          if (mn) notes.push(['check', mn]);
          if (cfg.note.clear) notes.push(['diya', cfg.note.clear]);

          text('[data-pl-out="width"]', width + ' in');
          text('[data-pl-out="height"]', height + ' in · ' + (height / 12).toFixed(1) + ' ft');
          text('[data-pl-out="idol"]', idol + ' in');
          var rs = el.querySelectorAll('.pk-pl-range');
          for (var r = 0; r < rs.length; r++) rs[r].setAttribute('aria-valuetext', rs[r].value + ' inches');
          text('[data-pl-name]', f.name || '');
          text('[data-pl-why]', f.why || '');
          text('[data-pl-w]', w + ' in');
          text('[data-pl-h]', h + ' in');
          text('[data-pl-d]', f.d[0] + '–' + f.d[1] + ' in');
          var imgs = el.querySelectorAll('[data-pl-img]');
          for (var m = 0; m < imgs.length; m++) {
            if (+imgs[m].getAttribute('data-pl-img') === fi) imgs[m].removeAttribute('hidden'); else imgs[m].setAttribute('hidden', '');
          }
          var ul = q('[data-pl-notes]');
          if (ul) {
            var html = '';
            for (var n = 0; n < notes.length; n++) {
              var sp = document.createElement('span'); sp.textContent = fill(notes[n][1], tok);
              html += '<li class="pk-pl-note"><span class="pk-pl-ni" aria-hidden="true">' + ico(notes[n][0]) + '</span>' + sp.outerHTML + '</li>';
            }
            ul.innerHTML = html;
          }
          var a = q('[data-pl-wa]');
          if (a && cfg.msg) {
            var msg = fill(cfg.msg, { place: f.label || f.name, width: width, height: height, idol: idol, posture: cfg.plab[post] || '', w: w, h: h });
            a.setAttribute('href', 'https://wa.me/' + cfg.num + '?text=' + encodeURIComponent(msg));
          }
        }
        function on() { if (!raf) raf = requestAnimationFrame(update); }
        el.addEventListener('input', on);
        el.addEventListener('change', on);
      })(els[e]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (ev) { bind(ev.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["think27-pk-tabs"] && !Shopify.designMode) return;
  try {
    
/* DZYN PageKit tabs (think27): THEME EDITOR ONLY - selecting an item block in the sidebar opens its panel. Customers never need this; the tabs work with CSS alone. */
document.addEventListener('shopify:block:select', function (e) {
  var id = e && e.detail && e.detail.blockId;
  if (!id) return;
  var r = document.querySelector('input.pk-tb2-r[data-pk-tb2-block="' + id + '"]');
  if (r) { r.checked = true; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["think27-tile-grid"] && !Shopify.designMode) return;
  try {
    
/* think27 tile grid: phone rail dot pager. State only - it toggles .is-on on a dot, never sizes anything. */
(function () {
  function bind(root) {
    var rails = root.querySelectorAll('[data-pk-gr-rail]');
    for (var r = 0; r < rails.length; r++) {
      (function (rail) {
        if (rail.getAttribute('data-pk-gr-bound')) return;
        rail.setAttribute('data-pk-gr-bound', '1');
        var dots = rail.nextElementSibling;
        if (!dots || !dots.classList.contains('pk-gr-dots')) return;
        var ds = dots.children, raf = 0;
        function update() {
          raf = 0;
          var kids = rail.children, mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = Infinity;
          for (var i = 0; i < kids.length; i++) {
            var d = Math.abs(kids[i].offsetLeft + kids[i].offsetWidth / 2 - mid);
            if (d < bd) { bd = d; best = i; }
          }
          for (var j = 0; j < ds.length; j++) ds[j].classList.toggle('is-on', j === best);
        }
        rail.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      })(rails[r]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
